import PropTypes from 'prop-types'
import React from 'react'
import { has, isEmpty } from 'lodash-es'
import { useSiteQuery } from '../../../global/blocs/useSite'

import './WebinarRoomHeaderComponent.scss'

const getLogo = (src, site) => {
  if (
    has(site, 'presentation_webinarRoomLogo') &&
    !isEmpty(site.presentation_webinarRoomLogo) &&
    has(site, 'files_folder')
  ) {
    return `${site.files_folder}/${site.presentation_webinarRoomLogo}`
  }

  if (src) {
    return src
  }

  return '/files/sitelogo.png'
}

const WebinarRoomHeaderComponent = ({ src, children }) => {
  const { data: site } = useSiteQuery()

  return (
    <div className="webinar-room-header-component">
      <img className="site-logo" src={getLogo(src, site)} alt="logo" />
      {children}
    </div>
  )
}

WebinarRoomHeaderComponent.propTypes = {
  src: PropTypes.string,
  children: PropTypes.node,
}

export default WebinarRoomHeaderComponent
